import { StarFilled } from '@ant-design/icons';
import { Layout } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { useContext } from 'react';

import { HotelContext } from 'app/context/HotelContext/HotelContext';
import { useReviews } from 'app/hooks/data/core/extranet/review/useReviews';

import { ExtranetHeader } from '../../commons/ExtranetHeader/ExtranetHeader';

import styles from './ExtranetReviews.module.scss';
import { ExtranetPackReviews } from './_components/ExtranetPackReviews';
import { ExtranetReviewsContent } from './_components/ExtranetReviewsContent';
import { usePacksSelection } from './hooks/usePackSelection';
import { useReviewsFilters } from './hooks/useReviewFilters';

const PAGE = 'Reviews';

export const ExtranetReviews = () => {
  const { hotelId } = useContext(HotelContext);
  const {
    filters,
    searchInput,
    setSearchInput,
    updateFilters,
    handleDateChange,
  } = useReviewsFilters();
  const {
    packIdsValue,
    setPackIdsValue,
    packsFilter,
    reviewsByPack,
    isReviewByPackLoading,
  } = usePacksSelection();

  const { data: reviews, isLoading } = useReviews(hotelId, {
    ...filters,
    packs: packsFilter,
  });

  const isMultiPack = !!reviewsByPack?.packs && reviewsByPack.packs.length > 1;

  const packFilterOptions =
    reviewsByPack?.packs.map((pack) => ({
      text: pack.nameForHotel,
      value: pack.id,
    })) ?? [];

  const renderHotelMarks = () => {
    if (!reviewsByPack?.packs.length || isMultiPack || isReviewByPackLoading) {
      return null;
    }

    return (
      <span className={styles.hotelMarks}>
        <span className={styles.star}>
          <StarFilled />
        </span>
        <span className={styles.average}>
          {reviewsByPack.packs[0].averageScore?.toFixed(1)}
        </span>
        <span className={styles.counter}>
          ({reviewsByPack.packs[0].feedbacksNumber})
        </span>
      </span>
    );
  };

  return (
    <Layout className={styles.extranetReviews}>
      <ExtranetHeader page={PAGE} subTitle={renderHotelMarks()} />
      <Content className={styles.body}>
        <ExtranetPackReviews
          isMultiPack={isMultiPack}
          packIdsValue={packIdsValue}
          setPackIdsValue={setPackIdsValue}
          reviewsByPack={reviewsByPack}
        />
        <ExtranetReviewsContent
          reviews={reviews?.data}
          isLoading={isLoading}
          filters={filters}
          updateFilters={updateFilters}
          pagination={reviews?.meta}
          searchInput={searchInput}
          setSearchInput={setSearchInput}
          handleDateChange={handleDateChange}
          isMultiPack={isMultiPack}
          packIdsValue={packIdsValue}
          setPackIdsValue={setPackIdsValue}
          packFilterOptions={packFilterOptions}
        />
      </Content>
    </Layout>
  );
};
